<div *ngIf="!expired"
    [ngClass]="{'has-lottie': countdownClockData.lottie?.src, 'revealed': revealClock === true}"
    [ngStyle]="{ opacity: revealClock ? 1 : 0 }"
    (finderInViewport)="setClockVisible()"
    requireFullElement="true"
    class="countdown-timer"
    role="region"
>
    <ng-container *ngIf="revealClock">
        @defer {
            <finder-lottie
                [data]="countdownClockData.lottie"
                [playback]="clockVisible"
            ></finder-lottie>
        }
        <h3 id="countdown-title" [innerHtml]="title | safeHtml"></h3>
        <div class="time">
            <div class="section" *ngFor="let format of formatArray;" aria-hidden="true">
                <div *ngIf="showCountup" class="countup"
                    [finderCountup]="getCountupData(dateData[format])"
                    (countupComplete)="countupComplete($event)">
                </div>
                <div class="group" [ngStyle]="style">
                    <div @displayNewNumber class="number"
                        *ngFor="let value of dateData[format].values; index as i; trackBy: trackByNumber">
                        <div [attr.data-position]="getPosition(i, format)">{{value}}</div>
                    </div>
                </div>
                <div class="label">{{dateData[format].label}}</div>
            </div>
        </div>
        <div class="hide" id="aria-clock" role="alert" aria-live="polite" aria-labelledby="countdown-title">
            {{getAriaClock()}}
        </div>
    </ng-container>
</div>
